export * from './request.model';
export * from './response.model';
export * from './account-opening-models/id-details.model';
export * from './account-opening-models/bank-details.model';
export * from './account-opening-models/nationality.model';
export * from './account-opening-models/account-application.model';
export * from './account-opening-models/person-income-detail.model';
export * from './account-opening-models/document-details.model';
export * from './account-opening-models/crs-details.model';
export * from './account-opening-models/fatca-details.model';
export * from './account-opening-models/benDetailsModel';